export const formatDocument = (data: string) => {
  let formatedData = data

  formatedData = formatedData.replace(/\./g, '')
  formatedData = formatedData.replace(/-/g, '')

  return formatedData
}
